// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Result, Spin, message } from 'antd';
import axios from 'axios';
import UserContext from '../../Contexts/UserContext';
import initAxiosGlobalConfigs from '../../API/axios.Config';
import { BASE_URL, PLATFORM_URL } from '../../Constants/EnvironmentVariableProvider';
import { GET_AGENT_CLAIM_DATA } from '../../API/paths';
import { RoutesLookup } from '../../Routes/RoutesLookup';

function SSOLogin() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const returnPath = searchParams.get('returnPath');
    const { auth, setAuth } = useContext(UserContext);
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        // Already logged in (e.g. route kept in list via ALLOW_ANY)
        // if (auth?.token) {

        //     navigate(returnPath || RoutesLookup.AGENT_DASHBOARD, { replace: true });
        //     return; 
        // }
        if (!token) {
            redirectToPlatform();
            return;
        } 

        localStorage.setItem('token', JSON.stringify(token));
        localStorage.setItem('loginSource', 'platform-sso');

        const urlForGet = `${BASE_URL}${GET_AGENT_CLAIM_DATA}`;
        axios.get(urlForGet, {
            headers: { Authorization: `Bearer ${token}` },
        }).then((res) => {
            if (res?.data?.success) {
                message.success('Login successful');
                setAuth(res.data);
                initAxiosGlobalConfigs(res.data);
                navigate(returnPath || RoutesLookup.AGENT_DASHBOARD, { replace: true });
            } else {
                console.error('SSO - API returned success:false', res?.data);
                setError('Authentication failed. Redirecting to platform...');
                setTimeout(redirectToPlatform, 3000);
            }
        }).catch((err) => {
            console.error('SSO - API error:', err?.response?.status, err?.response?.data, err?.message);
            setError(`Authentication failed (${err?.response?.status || 'network error'}). Redirecting to platform...`);
            setTimeout(redirectToPlatform, 3000);
        });
    }, [auth?.token, token, navigate, returnPath, setAuth]);

    const redirectToPlatform = () => {
        window.location.href = `${PLATFORM_URL}/Home`;
    };

    return (
        <Result
            style={{ marginTop: 100 }}
            icon={<Spin size="large" />}
            title={error || 'Signing you in...'}
            subTitle={error ? '' : 'Please wait while we verify your credentials.'}
        />
    );
}

export default SSOLogin;
